/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const attachment_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13 23H2.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.036a1 1 0 0 1 .764.354l4.963 5.866a1 1 0 0 1 .237.646V9m4.75 9.345-5.854-6.012a3.553 3.553 0 0 0-2.546-1.083c-.955 0-1.87.39-2.546 1.083a3.748 3.748 0 0 0-1.054 2.614c0 .98.38 1.92 1.054 2.614l4.809 4.937c.221.235.486.423.779.552a2.345 2.345 0 0 0 1.856.017 2.435 2.435 0 0 0 1.312-1.349 2.521 2.521 0 0 0-.553-2.705l-4.809-4.94a1.183 1.183 0 0 0-.844-.346 1.184 1.184 0 0 0-.838.36 1.249 1.249 0 0 0-.351.861 1.25 1.25 0 0 0 .337.867l4.808 4.94"
    />
  </svg>
)
export default attachment_medium
